<template>
  <div class="asc-previous-next-buttons">
    <div class="asc-previous-next-buttons--flex">
      <div class="asc-previous-next--container">
        <asc-link-button
          text="Previous"
          prepend-icon="mdi-chevron-left"
          :disabled="previousDisabled"
          @click="handlePreviousClick"
        ></asc-link-button>
      </div>
      <div class="asc-padding-divider">/</div>
      <div class="asc-previous-next--container">
        <asc-link-button
          text="Next"
          append-icon="mdi-chevron-right"
          :disabled="nextDisabled"
          @click="handleNextClick"
        ></asc-link-button>
      </div>
    </div>
  </div>
</template>

<script>
import { AscPreviousNextButtonsMixin } from '@/components/mixins'
import AscLinkButton from '@/components/atoms/AscLinkButton'

export default {
  name: 'AscPreviousNextButtons',

  components: {
    AscLinkButton,
  },

  mixins: [AscPreviousNextButtonsMixin],

  methods: {
    handlePreviousClick() {
      if (this.onPreviousReport) {
        this.onPreviousReport()
      }
    },

    handleNextClick() {
      if (this.onNextReport) {
        this.onNextReport()
      }
    },
  },
}
</script>

<style lang="scss">
.asc-previous-next-buttons {
  .asc-previous-next-buttons--flex {
    display: flex;

    & .asc-previous-next--container {
      & .asc-accent-button {
        width: 100%;
      }
    }

    & .asc-padding-divider {
      padding: 0 8px;
    }

    .v-btn {
      min-width: 10px;
    }
  }
}
</style>
